import {
  SAFEWALK_ALERT_ACTION_SUBMIT,
  SAFEWALK_ALERT_TIMELINE_ACTION_SUBMIT,
  SAFEWALK_ALERT_SUBMIT,
  SAFEWALK_CONTACTS_SUBMIT,
  SAFEWALK_SMS_SUBMIT,
  SAFEWALK_ALERT_TIMER_SUBMIT,
  SAFEWALK_ALERT_CANCEL_TIMER_SUBMIT,
  SAFEWALK_ALERT_UPDATE_LOCATION
} from '@actions/types'

export const addContactsAction = ({ apiKey, hash, contacts }) => ({
  type: SAFEWALK_CONTACTS_SUBMIT,
  payload: {
    client: 'v2',
    request: {
      method: 'post',
      url: `safewalk/v1/contacts/${hash}`,
      data: {
        emergency_contacts: contacts
      },
      headers: { 'x-api-key': apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})

export const submitSMSAlert = ({ auth, data }) => ({
  type: SAFEWALK_SMS_SUBMIT,
  payload: {
    client: 'v2',
    request: {
      method: 'post',
      url: `safewalk/v1/sms/${auth.accountHash}/${auth.hash}`,
      data,
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})

export const submitAlert = ({ auth, data }) => ({
  type: SAFEWALK_ALERT_SUBMIT,
  payload: {
    client: 'v2',
    request: {
      method: 'post',
      url: `safewalk/v1/alert/${auth.hash}`,
      data,
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})

export const submitAlertAction = ({ auth, data }) => ({
  type: SAFEWALK_ALERT_ACTION_SUBMIT,
  payload: {
    client: 'v2',
    request: {
      method: 'post',
      url: 'safewalk/v1/action',
      data: {
        ...data,
        account_hash: auth.accountHash,
        personal_access_code: auth.hash
      },
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})

export const submitTimeLineAction = ({ auth, data }) => ({
  type: SAFEWALK_ALERT_TIMELINE_ACTION_SUBMIT,
  payload: {
    client: 'v2',
    request: {
      method: 'post',
      url: `safewalk/v1/timeline/${auth.hash}`,
      data: {
        ...data,
        account_hash: auth.accountHash,
        personal_access_code: auth.hash
      },
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})

export const startTimerAction = ({ auth, data }) => ({
  type: SAFEWALK_ALERT_TIMER_SUBMIT,
  payload: {
    client: 'v2',
    request: {
      method: 'post',
      url: 'safewalk/v1/timer',
      data: {
        ...data,
        account_hash: auth.accountHash,
        personal_access_code: auth.hash
      },
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})

export const cancelTimerAction = ({ auth, data, timerId }) => ({
  type: SAFEWALK_ALERT_CANCEL_TIMER_SUBMIT,
  payload: {
    client: 'v2',
    request: {
      method: 'post',
      url: `safewalk/v1/timer/cancel/${auth.hash}/${timerId}`,
      data: {
        ...data,
        account_hash: auth.accountHash
      },
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})

export const updateLocationAction = ({ auth, data }) => ({
  type: SAFEWALK_ALERT_UPDATE_LOCATION,
  payload: {
    client: 'v2',
    request: {
      method: 'post',
      url: `safewalk/v1/location/${auth.hash}`,
      data,
      headers: { 'x-api-key': auth.apiKey }
    },
    setLoading: {
      meta: null
    }
  }
})
